import { render, staticRenderFns } from "./PageTableComponent.vue?vue&type=template&id=05e1245c"
import script from "./PageTableComponent.vue?vue&type=script&lang=js"
export * from "./PageTableComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports